export default {
  title: 'Run your business from anywhere',
  description: 'Login to your existing account.',
  form: {
    email: {
      label: 'Email',
      placeholder: 'Enter Email',
    },
    password: {
      label: 'Password',
      placeholder: 'Enter Password',
    },
    error_messages: {
      missing_info: 'Missing information',
      wrong_credentials: 'Wrong email or password',
    },
  },
  buttons: {
    login: 'Login',
    forgot_password: 'Forgot Password',
  },
  white_label: {
    title: 'Sign in to your dashboard',
    form: {
      email: {
        label: 'Email address',
        placeholder: 'you@restaurant.com',
      },
      password: {
        label: 'Password',
        placeholder: 'Enter your password',
      },
    },
    buttons: {
      login: 'Sign in',
    },
    intro: {
      eyebrow: 'Order management',
      headline: 'Run your restaurant from anywhere.',
      description: 'Orders, menus, opening hours and payouts — all in one place.',
      features: {
        live: {
          title: 'Live',
          subtitle: 'order tracking',
        },
        instant: {
          title: 'Instant',
          subtitle: 'menu changes',
        },
        any_device: {
          title: 'Any device',
          subtitle: 'phone or tablet',
        },
      },
    },
  },
};
